import React, { ReactElement, useState } from 'react';
import { initialContext, ProviderOtpModal } from './context';
import { OtpModalVM } from './types';
import ModalOtp from 'civil-status/components/shared/otp-button/modal-otp';
import useOtp from '../use-otp';
import { useEventCallback } from '@mui/material';
import { toast } from 'react-toastify';

interface Properties {
  children: ReactElement | ReactElement[];
}

/**
 * Component OtpModal
 * @param {Properties} props the root object
 * @returns {React.ReactComponentElement} the react component
 */
export const OtpModalProvider = ({ children }: Properties): ReactElement => {
  const [otpModal, setOtpModal] = useState<OtpModalVM['data']>(initialContext);

  const otp = useOtp();

  /**
   * open otp modal
   * @param {boolean} open the root object
   */
  const toggleModal = React.useCallback(
    (open) => {
      setOtpModal({ ...otpModal, open });
      return true;
    },
    [setOtpModal, otpModal]
  );

  const onSaveOTP = useEventCallback(() => {
    // OTP appena inserito quindi è valido
    otp.setValidity(true);
    // chiusura modale salvataggio OTP
    toggleModal(false);
    toast.success('Operazione eseguita con successo');
  });

  return (
    <ProviderOtpModal
      value={{
        data: otpModal || {},
        toggleModal: toggleModal,
      }}
    >
      {children}
      {otpModal.open ? (
        <ModalOtp
          onClose={() => {
            setOtpModal({ open: false });
          }}
          open={otpModal.open}
          // disabled={disabled}
          otpCodeInitialValues={otp.isValid ? otp.value || '' : ''}
          onSave={onSaveOTP}
        />
      ) : undefined}
    </ProviderOtpModal>
  );
};

OtpModalProvider.displayName = 'OtpModal Provider componet';
